var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "contact-distributions-by-language",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-wrapper" },
        [
          !_vm.tableMode
            ? _c("EChartsHorizontalBar", {
                attrs: {
                  labels: _vm.getLabels(),
                  datasets: _vm.getDatasets(),
                  height: _vm.getChartHeight(),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tableMode
            ? _c("TableView", {
                attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.mostUsedLanguage"),
              value: _vm.getStats().maxLanguage,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.leastUsedLanguage"),
              value: _vm.getStats().minLanguage,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.totalPersonCount"),
              value: _vm.formatStat(_vm.getStats().total).value,
              unit: "Kişi",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }